export default {
  'token.title': 'Gestionar Tokens para Reportes',
  'token.processInstance': 'Solicitud',
  'token.administration': 'Administración',
  'token.process': 'Proceso',
  'token.request': 'Solicitud',
  'token.generic': 'Genérico',
  'token.reportToken': 'Token para Reporte',
  'token.powerBIConnector': 'Conector de Power BI',
  'token.dynamicEntity': 'Entidad',
  'token.trace': 'Traza',
  'token.dataType': 'Tipo de Dato',
  'token.headers': 'Cabecera',
  'token.isSuccessfullyRequest': '¿Petición Satisfactoria?',
  'token.logs': 'Logs',
  'token.reportTokenId': 'Token de Reporte',
  'token.ip': 'IP',
};
